/* eslint no-unused-vars: 0 */

/**
 * This file was automatically generated by ruby_to_typescript.rake.
 * Do not modify it by hand.
 */
export enum RequestPartnerTypes {
  ACADEMIC_RESEARCHERS = "ACADEMIC_RESEARCHERS",
  STARTUPS = "STARTUPS",
  SUPPLIERS = "SUPPLIERS",
  SERVICE_PROVIDERS = "SERVICE_PROVIDERS",
  CONSULTANTS = "CONSULTANTS",
}
